/**
 * Whether the Time Tracking History page should be visible and accessible.
 *
 * Standard clients use the configured time-tracking access path. IRES users may
 * alternatively reach the page through the dedicated always-allowed override.
 */
export function canAccessTimeTrackingHistory(
  hasConfiguredTimeTrackingAccess: boolean,
  hasAlwaysAllowedOverride: boolean
) {
  return hasConfiguredTimeTrackingAccess || hasAlwaysAllowedOverride;
}